
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Copy, Share2, Users, Gift } from 'lucide-react';
import { toast } from '@/hooks/use-toast';

export const ReferralTab: React.FC = () => {
  const [referralCode] = useState('VIVE2024-ABC123');
  const [copiedCode, setCopiedCode] = useState(false);

  const handleCopyCode = async () => {
    try {
      await navigator.clipboard.writeText(referralCode);
      setCopiedCode(true);
      toast({
        title: "Código copiado!",
        description: "Seu código de indicação foi copiado para a área de transferência.",
      });
      setTimeout(() => setCopiedCode(false), 2000);
    } catch (err) {
      toast({
        title: "Erro ao copiar",
        description: "Não foi possível copiar o código. Tente novamente.",
        variant: "destructive"
      });
    }
  };

  const handleShare = async () => {
    const shareText = `Conheça a Vive Calme! Use meu código ${referralCode} e ganhe benefícios exclusivos. https://vivecalme.org`;
    
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Vive Calme - Indicação',
          text: shareText,
          url: 'https://vivecalme.org'
        });
      } catch (err) {
        console.log('Compartilhamento cancelado');
      }
    } else {
      try {
        await navigator.clipboard.writeText(shareText);
        toast({
          title: "Link copiado!",
          description: "Link de indicação copiado para compartilhar.",
        });
      } catch (err) {
        toast({
          title: "Erro ao copiar",
          description: "Não foi possível copiar o link.",
          variant: "destructive"
        });
      }
    }
  };

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Gift className="h-5 w-5" />
            Seu Código de Indicação
          </CardTitle>
          <CardDescription>
            Compartilhe com amigos e ganhe Seshs para cada pessoa que se cadastrar
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex gap-2">
            <Input 
              value={referralCode} 
              readOnly 
              className="font-mono text-center"
            />
            <Button 
              variant="outline" 
              onClick={handleCopyCode}
              className="px-3"
            >
              <Copy className="h-4 w-4" />
            </Button>
          </div>
          
          <Button 
            onClick={handleShare} 
            className="w-full"
            variant="default"
          >
            <Share2 className="h-4 w-4 mr-2" />
            Compartilhar Convite
          </Button>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Users className="h-5 w-5" />
            Como Funciona
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3 text-sm">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 rounded-full bg-brand-blue text-white flex items-center justify-center text-xs font-bold">1</div>
              <p>Compartilhe seu código com amigos</p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 rounded-full bg-brand-blue text-white flex items-center justify-center text-xs font-bold">2</div>
              <p>Quando eles se cadastrarem, vocês dois ganham 50 Seshs</p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 rounded-full bg-brand-blue text-white flex items-center justify-center text-xs font-bold">3</div>
              <p>Use seus Seshs para desbloquear recursos premium</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
